<template>
  <div class="other-floor">
    <img
      :src="require(`@assets/banner1.png`)"
      alt=""
      class="other-floor-banner"
    />
    <ph-search v-model="keyWrod" :placeholder="placeholder" />
    <ph-tabs :list="constructionList" @tabClick="tabClick" scrollable />
    <div class="other-floor-list">
      <div
        v-for="(item, index) in getList"
        :key="index"
        @click="showPopup(index)"
        class="other-floor-list-item"
      >
        <div>
          <div class="other-floor-list-item-icon">{{ item.floorIndex }}F</div>
          <span>{{ item.intro }}</span>
        </div>
        <div class="other-floor-list-item-show">查看平面图</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  components: {},
  data() {
    return {
      show: false,
      constructionList: [],
      constructionFloorList: [],
      navPic: "",
      keyWrod: "",
      linewidth: "",
      activeName: "",
      tabValue: 0,
      placeholder: "输入目的地搜索"
    };
  },
  computed: {
    getList() {
      const reg = new RegExp(this.keyWrod);
      const list = this.constructionFloorList.filter(item => {
        return reg.test(item.intro);
      });
      return list;
    }
  },
  created() {
    this.getFloorList();
  },
  methods: {
    showPopup(index) {
      this.navPic = this.constructionFloorList[index].navPic;
      if (this.navPic) {
        ImagePreview([this.navPic]);
      } else {
        this.$toast("暂无地图");
      }
    },
    getFloorList() {
      this.$http.post(this.$api.FLOORNAV_INIT).then(res => {
        this.constructionList = res.construction;
        this.constructionFloorList = res.firstConstructionFloor;
        this.active = this.constructionList[0].constructionId;
      });
    },
    getFirstConstructionFloor(name) {
      this.$http
        .post(this.$api.FLOORNAV_FLOOR, { constructionId: name })
        .then(res => {
          this.constructionFloorList = res;
        });
    },
    tabClick(item) {
      this.getFirstConstructionFloor(item.constructionId);
    }
  }
};
</script>

<style lang="less">
.other-floor {
  &-banner {
    width: 100%;
  }

  &-list {
    background: @primary-gray;

    &-item {
      border-bottom: solid 1px #ddd;

      > div {
        display: flex;
      }
      &-icon {
        flex-shrink: 0;
        width: 2rem;
        height: 2rem;
        margin: 0.94rem 0.63rem;
        color: #fff;
        font-size: 0.81rem;
        line-height: 2rem;
        text-align: center;
        background-color: #108ee9;
        border-radius: 50%;
      }
      span {
        margin-top: 0.94rem;
        margin-right: 0.2rem;
        font-size: 0.94rem;
      }
      &-show {
        display: block !important;
        margin-right: 0.63rem;
        color: #108ee9;
        font-size: 0.94rem;
        text-align: right;
      }
    }
  }
}
</style>
